// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header_headerMain__W-lOZ {
  border-bottom: 1px solid #e5e5e6;
  position: sticky;
  top: 0;
  z-index: 42;
  background: #fff;
}

.Header_container__TsUVY {
  padding: 0 24px;
}
@media (max-width: 1023px) {
  .Header_container__TsUVY {
    padding: 0 16px;
  }
}

.Header_listingContainer__xQBsU {
  width: 100%;
  max-width: 1320px;
  padding: 0 30px;
  margin: 0 auto;
}
@media (max-width: 1023px) {
  .Header_listingContainer__xQBsU {
    padding: 0 16px;
  }
}

.Header_headerWrapper__Y0JL0 {
  padding: 10px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (max-width: 767px) {
  .Header_headerWrapper__Y0JL0 {
    padding: 6px 0px;
  }
}
.Header_headerWrapper__Y0JL0 .Header_mainLogo__LsFgh {
  position: relative;
}
.Header_headerWrapper__Y0JL0 .Header_mobileHumberger__RVRbC {
  cursor: pointer;
}
@media (min-width: 768px) {
  .Header_headerWrapper__Y0JL0 .Header_mobileHumberger__RVRbC {
    display: none;
  }
}
.Header_headerWrapper__Y0JL0 .Header_mobileHumberger__RVRbC svg {
  width: 28px;
  height: 28px;
}
@media (min-width: 200px) {
  .Header_headerWrapper__Y0JL0 .Header_menuButtonsMobile__xU5OQ {
    display: none;
  }
}
.Header_headerWrapper__Y0JL0 .Header_menuButtons__fqVTy {
  display: flex;
  gap: 24px;
  margin-right: -100px;
}
@media (max-width: 767px) {
  .Header_headerWrapper__Y0JL0 .Header_menuButtons__fqVTy {
    display: none;
  }
}
.Header_headerWrapper__Y0JL0 .Header_menuButtons__fqVTy a {
  color: #fff;
  padding: 12px 36px;
  border-radius: 80px;
  text-decoration: none;
}
@media (max-width: 1023px) {
  .Header_headerWrapper__Y0JL0 .Header_menuButtons__fqVTy a {
    font-size: 14px;
  }
}
.Header_headerWrapper__Y0JL0 .Header_menuButtons__fqVTy a:nth-child(1) {
  background: rgb(230, 118, 87);
}
.Header_headerWrapper__Y0JL0 .Header_menuButtons__fqVTy a:nth-child(2) {
  background: rgb(192, 162, 184);
}
.Header_headerWrapper__Y0JL0 .Header_menuButtons__fqVTy a:nth-child(3) {
  background: rgb(95, 170, 189);
}
.Header_headerWrapper__Y0JL0 img {
  height: 64px;
  width: 74px;
  object-fit: contain;
}
@media (max-width: 767px) {
  .Header_headerWrapper__Y0JL0 img {
    height: 50px;
    width: 60px;
  }
}
.Header_headerWrapper__Y0JL0 svg, .Header_headerWrapper__Y0JL0 .Header_profileImage__soFor {
  height: 42px;
  width: 42px;
  border-radius: 100px;
  padding: 0;
}
.Header_headerWrapper__Y0JL0 .Header_profileImage__soFor {
  border: 1px solid gray;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
}
.Header_headerWrapper__Y0JL0 .Header_rightMenus__XsgVf {
  display: flex;
  gap: 16px;
  align-items: center;
  min-width: 36px;
}
.Header_headerWrapper__Y0JL0 .Header_rightMenus__XsgVf button {
  line-height: 36px;
}
.Header_headerWrapper__Y0JL0 .Header_rightMenus__XsgVf select {
  height: 40px;
  width: 95px;
}
.Header_headerWrapper__Y0JL0 .Header_userMenuWrapper__mS\\+Zx {
  position: relative;
  cursor: pointer;
}
@media (max-width: 767px) {
  .Header_headerWrapper__Y0JL0 .Header_userMenuWrapper__mS\\+Zx {
    display: none;
  }
}
.Header_headerWrapper__Y0JL0 .Header_userMenuContents__bK71A {
  padding: 16px 0px 16px;
  position: absolute;
  z-index: 30;
  right: 0;
  width: 250px;
  border-radius: 4px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.3);
  background-color: #fff;
}
.Header_headerWrapper__Y0JL0 .Header_userMenuContents__bK71A a, .Header_headerWrapper__Y0JL0 .Header_userMenuContents__bK71A button {
  white-space: pre;
  display: block;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 24px;
  background: transparent;
  border: none;
  border-radius: 0;
  cursor: pointer;
  line-height: 20px;
  text-align: left;
  color: #000;
  opacity: 0.8;
  position: relative;
}
.Header_headerWrapper__Y0JL0 .Header_userMenuContents__bK71A a:nth-child(1), .Header_headerWrapper__Y0JL0 .Header_userMenuContents__bK71A button:nth-child(1) {
  /* border-bottom: 1px solid grey; */
}
.Header_headerWrapper__Y0JL0 .Header_userMenuContents__bK71A a:hover, .Header_headerWrapper__Y0JL0 .Header_userMenuContents__bK71A button:hover {
  opacity: 1 !important;
}
.Header_headerWrapper__Y0JL0 .Header_userMenuContents__bK71A a:hover:after, .Header_headerWrapper__Y0JL0 .Header_userMenuContents__bK71A button:hover:after {
  position: absolute;
  content: "";
  width: 5px;
  height: 20px;
  background: #3d70a1;
  left: 0;
  transition: ease-in-out 0.1s;
}
.Header_headerWrapper__Y0JL0 .Header_userMenuContents__bK71A .Header_topArrowContent__aQhex {
  position: absolute;
  right: 11px;
  top: -10px;
  visibility: visible;
}
.Header_headerWrapper__Y0JL0 .Header_userMenuContents__bK71A .Header_topArrowContent__aQhex svg {
  width: 16px;
  height: 16px;
  fill: rgba(255, 251, 251, 0.7019607843);
  stroke: transparent;
}

.Header_mobileMenuContents__sgpaS {
  padding-top: 48px;
}
.Header_mobileMenuContents__sgpaS .Header_greetingName__L\\+05a {
  display: block;
  padding: 0 24px;
  font-size: 24px;
  font-weight: 700;
  margin: 16px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.Header_mobileMenuContents__sgpaS svg, .Header_mobileMenuContents__sgpaS .Header_profileImage__soFor {
  height: 96px;
  width: 96px;
  border-radius: 100px;
  padding: 0;
  margin-left: 24px;
}
.Header_mobileMenuContents__sgpaS .Header_profileImage__soFor {
  border: 1px solid gray;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
}
.Header_mobileMenuContents__sgpaS a, .Header_mobileMenuContents__sgpaS button {
  white-space: pre;
  display: block;
  text-decoration: none;
  font-size: 20px;
  font-weight: 700;
  padding: 4px 24px;
  background: transparent;
  border: none;
  border-radius: 0;
  cursor: pointer;
  line-height: 34px;
  text-align: left;
  color: #000;
  opacity: 0.7;
  position: relative;
}
.Header_mobileMenuContents__sgpaS a:nth-child(1), .Header_mobileMenuContents__sgpaS button:nth-child(1) {
  /* border-bottom: 1px solid grey; */
}
.Header_mobileMenuContents__sgpaS a:hover, .Header_mobileMenuContents__sgpaS button:hover {
  opacity: 1 !important;
}
.Header_mobileMenuContents__sgpaS a:hover:after, .Header_mobileMenuContents__sgpaS button:hover:after {
  position: absolute;
  content: "";
  width: 5px;
  height: 20px;
  background: #3d70a1;
  left: 0;
  transition: ease-in-out 0.1s;
}
@media (max-width: 767px) {
  .Header_mobileMenuContents__sgpaS a:hover:after, .Header_mobileMenuContents__sgpaS button:hover:after {
    position: absolute;
    content: "";
    width: 5px;
    height: 24px;
    background: #000 !important;
    left: 0px;
    transition: ease-in-out 0.1s;
    top: 9px;
  }
}

.Header_logoutButton__W9xDA {
  border-top: 1px solid #e5e5e6 !important;
  margin-top: 12px;
  line-height: 16px !important;
  padding-top: 16px !important;
  padding-bottom: 16px !important;
  margin-bottom: -12px;
  opacity: 0.6 !important;
}
@media (max-width: 767px) {
  .Header_logoutButton__W9xDA {
    border-top: none !important;
    font-size: 20px !important;
    margin-top: 0;
    margin-bottom: 12px;
    color: #b0b0b5 !important;
    font-weight: 700 !important;
  }
}

.Header_loginButton__99QUE {
  margin-top: 6px;
}
@media (max-width: 767px) {
  .Header_loginButton__99QUE {
    margin-top: 0;
  }
}

.Header_activeLink__VZiG4 {
  opacity: 1 !important;
}
.Header_activeLink__VZiG4:after {
  position: absolute;
  content: "";
  width: 5px;
  height: 20px;
  background: #000 !important;
  left: 0;
  transition: ease-in-out 0.1s;
}
@media (max-width: 767px) {
  .Header_activeLink__VZiG4:after {
    position: absolute;
    content: "";
    width: 5px;
    height: 24px;
    background: #000 !important;
    left: 0px;
    transition: ease-in-out 0.1s;
    top: 9px;
  }
}

.Header_closeModal__DF5Nk {
  height: 30px;
  width: 30px;
  color: #fff;
  border-radius: 100px;
  margin-left: auto;
  margin-right: 24px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 0;
}
@media (max-width: 1023px) {
  .Header_closeModal__DF5Nk {
    margin-right: 0;
    height: 24px;
    width: 24px;
    top: 16px;
    right: 16px;
  }
}
.Header_closeModal__DF5Nk svg {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;AACF;;AACA;EACE,eAAA;AAEF;AADE;EAFF;IAGI,eAAA;EAIF;AACF;;AAFA;EACE,WAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AAKF;AAJE;EALF;IAMI,eAAA;EAOF;AACF;;AALA;EACE,iBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAQF;AAPE;EALF;IAMI,gBAAA;EAUF;AACF;AATE;EACE,kBAAA;AAWJ;AAGE;EACE,eAAA;AADJ;AAEI;EAFF;IAGI,aAAA;EACJ;AACF;AAAI;EACE,WAAA;EACA,YAAA;AAEN;AAEI;EADF;IAEI,aAAA;EACJ;AACF;AACE;EACE,aAAA;EACA,SAAA;EACA,oBAAA;AACJ;AAAI;EAJF;IAKI,aAAA;EAGJ;AACF;AAFI;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;AAIN;AAHM;EALF;IAMI,eAAA;EAMN;AACF;AALM;EACE,6BAAA;AAOR;AALM;EACE,8BAAA;AAOR;AALM;EACE,6BAAA;AAOR;AAHE;EACE,YAAA;EACA,WAAA;EACA,mBAAA;AAKJ;AAJI;EAJF;IAKI,YAAA;IACA,WAAA;EAOJ;AACF;AALE;EAEE,YAAA;EACA,WAAA;EACA,oBAAA;EACA,UAAA;AAMJ;AAJE;EACE,sBAAA;EACA,2CAAA;AAMJ;AAJE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AAMJ;AALI;EACE,iBAAA;AAON;AALI;EACE,YAAA;EACA,WAAA;AAON;AAJE;EACE,kBAAA;EACA,eAAA;AAMJ;AALI;EAHF;IAII,aAAA;EAQJ;AACF;AANE;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,2CAAA;EACA,sBAAA;AAQJ;AAPI;EAEE,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAQN;AAPM;EACE,mCAAA;AASR;AAPM;EACE,qBAAA;AASR;AAPQ;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,OAAA;EACA,4BAAA;AASV;AALI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;AAON;AANM;EACE,WAAA;EACA,YAAA;EACA,uCAAA;EACA,mBAAA;AAQR;;AAHA;EACE,iBAAA;AAMF;AALE;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AAOJ;AALE;EAEE,YAAA;EACA,WAAA;EACA,oBAAA;EACA,UAAA;EACA,iBAAA;AAMJ;AAJE;EACE,sBAAA;EACA,2CAAA;AAMJ;AAJE;EAEE,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAKJ;AAJI;EACE,mCAAA;AAMN;AAJI;EACE,qBAAA;AAMN;AAJM;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,OAAA;EACA,4BAAA;AAMR;AALQ;EARF;IASI,kBAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;IACA,2BAAA;IACA,SAAA;IACA,4BAAA;IACA,QAAA;EAQR;AACF;;AAHA;EACE,wCAAA;EACA,gBAAA;EACA,4BAAA;EACA,4BAAA;EACA,+BAAA;EACA,oBAAA;EACA,uBAAA;AAMF;AALE;EARF;IASI,2BAAA;IACA,0BAAA;IACA,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,2BAAA;EAQF;AACF;;AANA;EACE,eAAA;AASF;AARE;EAFF;IAGI,aAAA;EAWF;AACF;;AATA;EACE,qBAAA;AAYF;AAXE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,2BAAA;EACA,OAAA;EACA,4BAAA;AAaJ;AAZI;EARF;IASI,kBAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;IACA,2BAAA;IACA,SAAA;IACA,4BAAA;IACA,QAAA;EAeJ;AACF;;AAZA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AAeF;AAdE;EAXF;IAYI,eAAA;IACA,YAAA;IACA,WAAA;IACA,SAAA;IACA,WAAA;EAiBF;AACF;AAhBE;EACE,WAAA;EACA,YAAA;AAkBJ","sourcesContent":[".headerMain {\r\n  border-bottom: 1px solid #e5e5e6;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 42;\r\n  background: #fff;\r\n}\r\n.container {\r\n  padding: 0 24px;\r\n  @media (max-width: 1023px) {\r\n    padding: 0 16px;\r\n  }\r\n}\r\n.listingContainer {\r\n  width: 100%;\r\n  max-width: 1320px;\r\n  padding: 0 30px;\r\n  margin: 0 auto;\r\n  @media (max-width: 1023px) {\r\n    padding: 0 16px;\r\n  }\r\n}\r\n.headerWrapper {\r\n  padding: 10px 0px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  @media (max-width: 767px) {\r\n    padding: 6px 0px;\r\n  }\r\n  & .mainLogo {\r\n    position: relative;\r\n    // &:hover{\r\n    //   &:after{\r\n    //     position: absolute;\r\n    //     content: \"\";\r\n    //     width: 100%;\r\n    //     height: 4px;\r\n    //     background: #3d70a1;\r\n    //     bottom: -13px;\r\n    //     right: 0;\r\n    //     left: 0;\r\n    //   }\r\n    // }\r\n  }\r\n  & .mobileHumberger {\r\n    cursor: pointer;\r\n    @media (min-width: 768px) {\r\n      display: none;\r\n    }\r\n    & svg {\r\n      width: 28px;\r\n      height: 28px;\r\n    }\r\n  }\r\n  & .menuButtonsMobile {\r\n    @media (min-width: 200px) {\r\n      display: none;\r\n    }\r\n  }\r\n  & .menuButtons {\r\n    display: flex;\r\n    gap: 24px;\r\n    margin-right: -100px;\r\n    @media (max-width: 767px) {\r\n      display: none;\r\n    }\r\n    & a {\r\n      color: #fff;\r\n      padding: 12px 36px;\r\n      border-radius: 80px;\r\n      text-decoration: none;\r\n      @media (max-width: 1023px) {\r\n        font-size: 14px;\r\n      }\r\n      &:nth-child(1) {\r\n        background: rgb(230 118 87);\r\n      }\r\n      &:nth-child(2) {\r\n        background: rgb(192 162 184);\r\n      }\r\n      &:nth-child(3) {\r\n        background: rgb(95 170 189);\r\n      }\r\n    }\r\n  }\r\n  & img {\r\n    height: 64px;\r\n    width: 74px;\r\n    object-fit: contain;\r\n    @media (max-width: 767px) {\r\n      height: 50px;\r\n      width: 60px;\r\n    }\r\n  }\r\n  & svg,\r\n  & .profileImage {\r\n    height: 42px;\r\n    width: 42px;\r\n    border-radius: 100px;\r\n    padding: 0;\r\n  }\r\n  & .profileImage {\r\n    border: 1px solid gray;\r\n    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);\r\n  }\r\n  & .rightMenus {\r\n    display: flex;\r\n    gap: 16px;\r\n    align-items: center;\r\n    min-width: 36px;\r\n    & button {\r\n      line-height: 36px;\r\n    }\r\n    & select {\r\n      height: 40px;\r\n      width: 95px;\r\n    }\r\n  }\r\n  & .userMenuWrapper {\r\n    position: relative;\r\n    cursor: pointer;\r\n    @media (max-width: 767px) {\r\n      display: none;\r\n    }\r\n  }\r\n  & .userMenuContents {\r\n    padding: 16px 0px 16px;\r\n    position: absolute;\r\n    z-index: 30;\r\n    right: 0;\r\n    width: 250px;\r\n    border-radius: 4px;\r\n    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.3);\r\n    background-color: #fff;\r\n    & a,\r\n    & button {\r\n      white-space: pre;\r\n      display: block;\r\n      text-decoration: none;\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      padding: 4px 24px;\r\n      background: transparent;\r\n      border: none;\r\n      border-radius: 0;\r\n      cursor: pointer;\r\n      line-height: 20px;\r\n      text-align: left;\r\n      color: #000;\r\n      opacity: 0.8;\r\n      position: relative;\r\n      &:nth-child(1) {\r\n        /* border-bottom: 1px solid grey; */\r\n      }\r\n      &:hover {\r\n        opacity: 1 !important;\r\n        // font-weight: 600;\r\n        &:after {\r\n          position: absolute;\r\n          content: \"\";\r\n          width: 5px;\r\n          height: 20px;\r\n          background: #3d70a1;\r\n          left: 0;\r\n          transition: ease-in-out 0.1s;\r\n        }\r\n      }\r\n    }\r\n    & .topArrowContent {\r\n      position: absolute;\r\n      right: 11px;\r\n      top: -10px;\r\n      visibility: visible;\r\n      & svg {\r\n        width: 16px;\r\n        height: 16px;\r\n        fill: #fffbfbb3;\r\n        stroke: transparent;\r\n      }\r\n    }\r\n  }\r\n}\r\n.mobileMenuContents {\r\n  padding-top: 48px;\r\n  & .greetingName {\r\n    display: block;\r\n    padding: 0 24px;\r\n    font-size: 24px;\r\n    font-weight: 700;\r\n    margin: 16px 0 0;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 1;\r\n    -webkit-box-orient: vertical;\r\n  }\r\n  & svg,\r\n  & .profileImage {\r\n    height: 96px;\r\n    width: 96px;\r\n    border-radius: 100px;\r\n    padding: 0;\r\n    margin-left: 24px;\r\n  }\r\n  & .profileImage {\r\n    border: 1px solid gray;\r\n    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);\r\n  }\r\n  & a,\r\n  & button {\r\n    white-space: pre;\r\n    display: block;\r\n    text-decoration: none;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    padding: 4px 24px;\r\n    background: transparent;\r\n    border: none;\r\n    border-radius: 0;\r\n    cursor: pointer;\r\n    line-height: 34px;\r\n    text-align: left;\r\n    color: #000;\r\n    opacity: 0.7;\r\n    position: relative;\r\n    &:nth-child(1) {\r\n      /* border-bottom: 1px solid grey; */\r\n    }\r\n    &:hover {\r\n      opacity: 1 !important;\r\n      // font-weight: 600;\r\n      &:after {\r\n        position: absolute;\r\n        content: \"\";\r\n        width: 5px;\r\n        height: 20px;\r\n        background: #3d70a1;\r\n        left: 0;\r\n        transition: ease-in-out 0.1s;\r\n        @media (max-width: 767px) {\r\n          position: absolute;\r\n          content: \"\";\r\n          width: 5px;\r\n          height: 24px;\r\n          background: #000 !important;\r\n          left: 0px;\r\n          transition: ease-in-out 0.1s;\r\n          top: 9px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.logoutButton {\r\n  border-top: 1px solid #e5e5e6 !important;\r\n  margin-top: 12px;\r\n  line-height: 16px !important;\r\n  padding-top: 16px !important;\r\n  padding-bottom: 16px !important;\r\n  margin-bottom: -12px;\r\n  opacity: 0.6 !important;\r\n  @media (max-width: 767px) {\r\n    border-top: none !important;\r\n    font-size: 20px !important;\r\n    margin-top: 0;\r\n    margin-bottom: 12px;\r\n    color: #b0b0b5 !important;\r\n    font-weight: 700 !important;\r\n  }\r\n}\r\n.loginButton {\r\n  margin-top: 6px;\r\n  @media (max-width: 767px) {\r\n    margin-top: 0;\r\n  }\r\n}\r\n.activeLink {\r\n  opacity: 1 !important;\r\n  &:after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 5px;\r\n    height: 20px;\r\n    background: #000 !important;\r\n    left: 0;\r\n    transition: ease-in-out 0.1s;\r\n    @media (max-width: 767px) {\r\n      position: absolute;\r\n      content: \"\";\r\n      width: 5px;\r\n      height: 24px;\r\n      background: #000 !important;\r\n      left: 0px;\r\n      transition: ease-in-out 0.1s;\r\n      top: 9px;\r\n    }\r\n  }\r\n}\r\n.closeModal {\r\n  height: 30px;\r\n  width: 30px;\r\n  color: #fff;\r\n  border-radius: 100px;\r\n  margin-left: auto;\r\n  margin-right: 24px;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  top: 20px;\r\n  right: 0;\r\n  @media (max-width: 1023px) {\r\n    margin-right: 0;\r\n    height: 24px;\r\n    width: 24px;\r\n    top: 16px;\r\n    right: 16px;\r\n  }\r\n  & svg {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerMain": `Header_headerMain__W-lOZ`,
	"container": `Header_container__TsUVY`,
	"listingContainer": `Header_listingContainer__xQBsU`,
	"headerWrapper": `Header_headerWrapper__Y0JL0`,
	"mainLogo": `Header_mainLogo__LsFgh`,
	"mobileHumberger": `Header_mobileHumberger__RVRbC`,
	"menuButtonsMobile": `Header_menuButtonsMobile__xU5OQ`,
	"menuButtons": `Header_menuButtons__fqVTy`,
	"profileImage": `Header_profileImage__soFor`,
	"rightMenus": `Header_rightMenus__XsgVf`,
	"userMenuWrapper": `Header_userMenuWrapper__mS+Zx`,
	"userMenuContents": `Header_userMenuContents__bK71A`,
	"topArrowContent": `Header_topArrowContent__aQhex`,
	"mobileMenuContents": `Header_mobileMenuContents__sgpaS`,
	"greetingName": `Header_greetingName__L+05a`,
	"logoutButton": `Header_logoutButton__W9xDA`,
	"loginButton": `Header_loginButton__99QUE`,
	"activeLink": `Header_activeLink__VZiG4`,
	"closeModal": `Header_closeModal__DF5Nk`
};
export default ___CSS_LOADER_EXPORT___;
